import { format } from "date-fns"
import h from "../../core/createElement"
import Btn from "../btn"

export default function ReportCard({ data: { name, updated_at, id }, onClick, onHighlight, onDismissHighlight }) {
    const highlight_report = (evt) => {
        evt.stopImmediatePropagation();

        if(card.classList.contains("highlighted-in-overlay")){
            card.classList.remove("highlighted-in-overlay"); 
            onDismissHighlight && onDismissHighlight();
            return;
        };

        card.classList.add("highlighted-in-overlay");
        onHighlight && onHighlight({ name, id });
    };
    /**@type {HTMLElement} */
    const card = (
        <article class="card hover" id={'report_card_' + id} onClick={() => onClick({ id })}>
            <div class="top">
                <span class="title">{name}</span>
                <span class="sub">{id}</span>
            </div>
            <div class="bottom">
                <span class="blue"><strong>MOD: </strong>{format(updated_at, "dd/MM/yyyy HH:mm")}</span>
                <Btn color="purple" onClick={highlight_report} icon="assets/image/funnel.svg" />
            </div>
        </article>
    );

    return card;
};

